import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Components
import ProfileImage from './ProfileImage'
import ProfileImageSocialMediaIcons from './ProfileImageSocialMediaIcons'
import ProfileNav from './ProfileNav'
import ProfileBio from './ProfileBio'
import ProfileRatings from './ProfileRatings'
import ProfileHeaderStats from './ProfileHeaderStats'
import TabSelect from '../../components/Global/TabSelect'

// Assets
import profileImage from '../../assets/images/sports/iStock-845800334.jpg'

import sportAndImageNames from '../../utils/data/sportAndImageNames'

const heroImageFilenames = sportAndImageNames.reduce((accumulator, data) => {
  accumulator[data.sportName] = data.imageName
  return accumulator
}, {})


class ProfileHeader extends Component {
  static propTypes = {
    // Required
    profile: PropTypes.object.isRequired,
    participation: PropTypes.object.isRequired,
    profileNav: PropTypes.bool.isRequired,
    // Optional
    selectedParticipation: PropTypes.object,
    selectedSection: PropTypes.string,
  }

  state = {
    heroImages: [],
    tabs: []
  }

  componentDidMount() {
    this.importHeroImages(
      require.context('../../assets/images/hero-backgrounds', false, /\.(png|jpe?g|svg)$/)
    )
    this.setAvailableTabs()
  }

  importHeroImages(route) {
    let images = {}
    route.keys().map((item, index) => {
      return images[item.replace('./', '')] = route(item)
    })

    this.setState({ heroImages: images })
  }

  getHeroImagePath = () => {
    const { selectedParticipation } = this.props
    const { heroImages } = this.state

    const filename = heroImageFilenames[selectedParticipation.sport_name] || 'football.jpg'
    return heroImages[filename]
  }

  profileImageUrl = () => this.props.participation.profile_image_url || profileImage

  socialMediaData = () => {
    const { profile } = this.props

    return [
      {
        name: 'facebook',
        url: profile.facebook_username ? profile.facebook_username : null,
      },
      {
        name: 'hudl',
        url: profile.hudl_username ? profile.hudl_username : null,
      },
      {
        name: 'twitter',
        url: profile.twitter_username ? profile.twitter_username : null,
      }
    ]
  }

  setAvailableTabs() {
    const { profile, participation } = this.props

    const {
      awards,
      seasons,
      camps,
      contacts,
      sport
    } = participation

    let profileTab = {
      path: `/${profile.username}/${sport.slug}/profile`,
      title: 'Profile',
      slug: 'profile'
    }

    let initialTabs = [profileTab]

    // Awards Tab
    if (awards.length > 0) {
      initialTabs.push({
        path: `/${profile.username}/${sport.slug}/awards`,
        title: 'Awards',
        slug: 'awards'
      })
    }

    // Stats Tab
    if (seasons.length > 0) {
      initialTabs.push({
        path: `/${profile.username}/${sport.slug}/stats`,
        title: 'Stats',
        slug: 'stats'
      })
    }

    // Camps Tab
    if (camps.length > 0) {
      initialTabs.push({
        path: `/${profile.username}/${sport.slug}/camps`,
        title: 'Camps',
        slug: 'camps'
      })
    }

    // Contact Tab
    if (
      contacts.coaches.length > 0 ||
      contacts.counselors.length > 0 ||
      contacts.references.length > 0 ||
      contacts.school !== null
    ) {
      initialTabs.push({
        path: `/${profile.username}/${sport.slug}/contact`,
        title: 'Contact',
        slug: 'contact'
      })
    }

    this.setState({
      tabs: initialTabs
    })
  }

  render() {
    const { tabs } = this.state
    const {
      profile,
      participation,
      selectedParticipation,
      selectedSection,
      profileNav,
      profileTabSelect,
      profileRatings,
      keyMetrics,
    } = this.props

    const rankingsMoreThanThree = participation.rankings.length > 3 ? true :false

    return (
      <div>
        { participation &&
          <section
            className='profile-header'
            style={ {backgroundImage: `url(${this.getHeroImagePath()})`} }
          >
            <div className={`inner-wrap profile-header-main${rankingsMoreThanThree ? ' four-plus-rankings' : ''}`}>
              <ProfileImage
                image={this.profileImageUrl()}
                >
                <ProfileImageSocialMediaIcons
                  socialMedia={ this.socialMediaData() }
                />
              </ProfileImage>
              <div className="profile-header-details">
                { profileNav &&
                  <ProfileNav
                    profile={ profile }
                    selectedParticipation={ selectedParticipation }
                  />
                }
                <ProfileBio
                  profile={ profile }
                  participation={ participation }
                />
              </div>
              { (profileRatings && participation.rankings.length > 0) &&
                <ProfileRatings
                  ratings={ participation.rankings }
                />
              }
            </div>
            <ProfileHeaderStats
              profile={ profile }
              participation={ participation }
              keyMetrics={ keyMetrics }
            />
            { profileTabSelect &&
              <TabSelect
                breakpoint={860}
                tabs={tabs}
                currentTabSlug={selectedSection}
              />
            }
          </section>
        }
      </div>
    )
  }
}

export default ProfileHeader



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileHeader.js